import { QueryClient } from 'react-query';
import { auth } from './firestore/firebase';
import { UseQueryParams } from './firestore/useHttpQuery';
import { QueryError, getQueryErrorCode } from './firestore/errors';

const createRequestHeaders = async () => {
    const headers: Record<string, string> = {
        'Content-Type': 'application/json',
    };
    if (auth.currentUser) {
        const idToken = await auth.currentUser.getIdToken();
        headers.Authorization = `Bearer ${idToken}`;
    }
    return headers;
};

const fetchDataForQuery = <T>(queryClient: QueryClient, params: UseQueryParams) => {
    const {
        pathname,
        method = 'GET',
        server = process.env.REACT_APP_BASE_URL,
        body,
        key,
        queryOptions = {},
    } = params;
    const url = new URL(pathname, server).toString();
    const queryKey = key || [`${method} ${url}`];

    return queryClient.fetchQuery<T>(
        queryKey,
        async () => {
            try {
                const response = await fetch(url, {
                    method,
                    body: body ? JSON.stringify(body) : null,
                    headers: await createRequestHeaders(),
                });
                if (response.ok) {
                    return response.json() as T;
                }
                if (response.headers.get('content-type')?.includes('text/html')) {
                    const result = await response.text();
                    throw new QueryError(getQueryErrorCode(response.status), result);
                }
                const result = await response.json();
                throw result;
            } catch (error) {
                if (error instanceof QueryError) {
                    throw error;
                } else {
                    throw new QueryError('unknown');
                }
            }
        },
        queryOptions,
    );
};

export default fetchDataForQuery;
